import React from 'react';
import axios from '../../services/axios'

import Header from './Header';
import Body from './Body';

// textos
import Texts from './Text'
import { withRouter } from 'react-router-dom'

class Somos extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            form: { email: '', password: '' },
            images: [],
            language: props.language,
            text: new Texts(props.language),
        }

        this.handleInputChange = this.handleInputChange.bind(this)
        this.imagesHandle = this.imagesHandle.bind(this)
        this.handleLanguage = props.handleLanguage.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.routeChange = this.routeChange.bind(this)
    }

    componentDidMount(){
        window.scrollTo(0, 0);
    }

    handleInputChange(e) {
        e.preventDefault()
        let form = Object.assign({}, this.state.form)
        form[e.target.name] = e.target.value
        this.setState({form})
    }

    login = async () => {
        try {
            const response = axios.post('/login', this.state.form)
        } catch(err) { console.error(err) }
    }

    imagesHandle = async () => {
        try {
            const response = axios.get('/imagens', { Authorization: this.state.token })
            this.setState({images: response.data})
        } catch(err) { console.error(err) }
    }

    handleChangeText(lang) {
        this.handleLanguage(lang)
        this.setState({ text: new Texts(lang) })
    }

    routeChange(route) {
        let path = `/${route}`;
        this.props.history.push(path);
    }

    render() {

        return (
            <div>
                <Header text={this.state.text} handleInputChange={this.handleInputChange}
                    handleLanguage={this.handleChangeText} login={this.login} 
                    language={this.state.language} />
                <Body text={this.state.text} imagens={this.state.images} 
                    language={this.state.language} routeChange={this.routeChange} 
                    />
            </div>
        )
    }
}

export default withRouter(Somos)